import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";

const openDrawer = () => {
  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
  const ObFlag = tillData?.tillAccess?.cwrTill?.tillCloseTemplate?.obController === "Y" ? true : false;
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  let openDrawerPayload = "";
  if (CWHardwareController) {
    openDrawerPayload = JSON.stringify({
      cash_drawer: {
        action: "open",
      },
    });
  } else if (ObFlag) {
    openDrawerPayload = `<?xml version="1.0" encoding="UTF-8"?>
      <output>
      <opendrawer/>
      </output>`;
  }

  Axios.post(`${printerURL}printer`, openDrawerPayload, {
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  })
    .then(() => {
      console.debug("openDrawer success!");
    })
    .catch((response) => {
      console.debug("openDrawer failed!", response);
    });
};

export default openDrawer;
